import React from 'react';
import { Box, Typography, Stack } from '@mui/material';
import StarIcon from '@mui/icons-material/Star';
import StarHalfIcon from '@mui/icons-material/StarHalf';
import img from './img/googleImg.jpg';

const ReviewPage = () => {
    return (
        <Box
            sx={{
                px: { xs: 2, md: 6 },
                py: { xs: 4, md: 6 },
                borderBottom: '1px solid #e0e0e0',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                flexDirection: { xs: 'column', md: 'row' },
                gap: 2,
                textAlign: 'center'
            }}
        >
            {/* Rating text */}
            <Typography
                variant="body1"
                sx={{ fontWeight: 600, fontSize: { xs: '1.3rem', md: '1..3rem' }, color: '#555' }}
            >
                Excellent
            </Typography>

            {/* Stars */}
            <Stack direction="row" spacing={0.3}>
                {[...Array(4)].map((_, i) => (
                    <StarIcon key={i} sx={{ color: '#00C851', fontSize: '1.5rem' }} />
                ))}
                <StarHalfIcon sx={{ color: '#00C851', fontSize: '1.4rem' }} />
            </Stack>

            {/* Score text */}
            <Typography
                variant="body1"
                sx={{ fontWeight: 600, fontSize: { xs: '1.3rem', md: '1.3rem' }, color: '#00C851' }}
            >
                4.4 out of 5
            </Typography>

            {/* Reviews count */}
            <Typography
                variant="body1"
                sx={{ fontWeight: 600, fontSize: { xs: '1.3rem', md: '1.3rem' }, color: '#555' }}
            >
                based on 660 reviews
            </Typography>

            {/* Google logo */}
            <Box
                component="img"
                src={img}
                alt="Google"
                sx={{
                    height: { xs: 120, md: 120 },
                    width: 'auto',
                    ml: { md: 1 },
                    mt: { xs: 1, md: 0 }
                }}
            />
        </Box>
    );
};

export default ReviewPage;
